declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/header.scss';

import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import Mobilemenutoggle from './mobilemenutoggle';
import Illustration from './illustration';

export default class header extends Component<any, any> {
  
  constructor() {
    super();
    
    this.setState({showFirstMenu: false, showSecondMenu: false});
  }
  
  toggleFirstMenu = () => {
    this.setState({showFirstMenu: !this.state.showFirstMenu, showSecondMenu: false});
  };
  
  toggleSecondMenu = () => {
    this.setState({showSecondMenu: !this.state.showSecondMenu, showFirstMenu: false});
  };
  
  public render (props, state): any {
    return <header>
      <div class="mainWrp">
        <div class="logo">
          <a href={BASE_URL}>
            <Illustration src={STATIC_BASE_URL + 'images/logo-querlo'} alt="Querlo Home"/>
            <div>Artificial Intelligence with a 💖</div>
          </a>
        </div>
        <Mobilemenutoggle cb={props.cb}/>
        <nav id="mainMenu" class="main-nav menuItemCheck" role="navigation">
          <ul>
            <li><Link activeClassName="sel" href={BASE_URL + 'about'}>About</Link></li>
            <li class={ this.state.showFirstMenu ? "hovered" : "" } onMouseOver={this.toggleFirstMenu} onMouseOut={this.toggleFirstMenu}>
              <a>Products</a>
              <ul>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/forbes-lead-insights'}>Forbes Lead
                  Insights</Link></li>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/hr-assistant'}>HR Digital Assistant</Link></li>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/chatbot-studio'}>Chatbot Studio</Link></li>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/online-lead-gen'}>Lead Gen</Link></li>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/enterprise-solution'}>Enterprise
                  Solution</Link></li>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/chatbot-assistant'}>Chatbot Assistant</Link>
                </li>
                <li><Link activeClassName="sel" href={BASE_URL + 'products/ai-social-lab'}>AI Social Lab</Link></li>
              </ul>
            </li>
            <li class={ this.state.showSecondMenu ? "hovered" : "" } onMouseOver={this.toggleSecondMenu} onMouseOut={this.toggleSecondMenu}>
              <a>Partners</a>
              <ul>
                <li><Link activeClassName="sel" href={BASE_URL + 'partners/list'}>Our Partners</Link></li>
                <li><Link activeClassName="sel" href={BASE_URL + 'partners/join'}>Become a Partner</Link></li>
              </ul>
            </li>
            <li><Link activeClassName="sel" href={BASE_URL + 'careers'}>Careers</Link></li>
            <li><a href="https://blog.querlo.com" target="_blank">Blog</a></li>
            <li><a href="https://blog.querlo.com/category/documentation" target="_blank">Documentation</a></li>
            <li><Link activeClassName="sel" href={BASE_URL + 'contacts'}>Contacts</Link></li>
            <li class="accessButt register"><a href={BASE_URL + 'register'} native>Try it free</a></li>
            <li class="accessButt login"><a href={BASE_URL + 'login'} native>Sign in</a></li>
          </ul>
        </nav>
      </div>
    </header>;
  }

};



// WEBPACK FOOTER //
// ./ts/header.tsx